<template>
    <v-card class="round-card background-2 mt-4 pb-3" v-if="contracts.length > 0">
        <v-card-title class="pa-3 cursor-pointer" @click="expanded = !expanded">
            <v-icon color="success" class="mr-2">mdi-file-document-outline</v-icon>
            <span class="subtitle-2">Contratti ({{ contracts.length }})</span>
            <v-spacer></v-spacer>
            <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-card-title>

        <v-expand-transition>
            <div v-show="expanded">
                <v-divider></v-divider>
                <v-list dense class="pa-0 background-2">
                    <v-list-item
                        v-for="contract in contracts"
                        :key="contract.id"
                        @click="openContract(contract.id)"
                        @click.middle="openContract(contract.id, true)"
                        class="cursor-pointer"
                    >
                        <v-list-item-content>
                            <v-list-item-subtitle class="d-flex align-center justify-space-between">
                                <span>{{ formatDateRange(contract.activation_date, contract.expiration_date) }}</span>
                                <v-chip v-if="contract.contract_type_text" x-small :color="contract.contract_type_color || 'grey'" dark>
                                    {{ contract.contract_type_text }}
                                </v-chip>
                            </v-list-item-subtitle>
                            <v-list-item-title class="d-flex align-center">
                                <span class="font-weight-bold mr-2">{{ contract.code }}</span>
                                <span class="text-truncate">{{ contract.name }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import { format } from 'date-fns'

export default {
    name: 'CompanyContracts',

    props: {
        companyId: {
            type: Number,
            required: true
        },
        currentContractId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            contracts: [],
            loading: false,
            expanded: true
        }
    },

    watch: {
        companyId: {
            immediate: true,
            handler(val) {
                if (val) this.loadContracts()
            }
        }
    },

    methods: {
        async loadContracts() {
            if (!this.companyId) return

            this.loading = true
            try {
                const params = {}
                if (this.currentContractId) {
                    params.exclude_id = this.currentContractId
                }
                const response = await this.axios.get(`helpdesktroubles/company/${this.companyId}/contracts`, { params })
                this.contracts = response.data.data || []
            } catch (error) {
                console.error('Error loading company contracts:', error)
            } finally {
                this.loading = false
            }
        },

        openContract(contractId, blank = false) {
            if(blank) {
                const url = this.$router.resolve({name: 'helpdeskcontracts-show', params: { id: contractId }}).href
                window.open(url, '_blank')
                return
            } else {
                this.$router.push({name: 'helpdeskcontracts-show', params: { id: contractId }})
            }
        },

        formatDateRange(start, end) {
            const startStr = start ? format(new Date(start), 'dd/MM/yy') : ''
            const endStr = end ? format(new Date(end), 'dd/MM/yy') : ''
            return `${startStr} - ${endStr}`
        }
    }
}
</script>
